<template>
  <div 
    class="cpt-count-down"
    :style="{
      '--switch-on-color': cc.switch_on_color,
      '--switch-off-color': cc.switch_off_color,
    }"
  >
    <div class="count-down-wrapper">
      <div class="timer">
        <span class="time-num" :style="{ background: cc.countdown_bg }"><p :style="{ color: cc.countdown_time_color }">{{getTimeNumber ('hour', 0)}}</p></span>
        <span class="time-num" :style="{ background: cc.countdown_bg }"><p :style="{ color: cc.countdown_time_color }">{{getTimeNumber ('hour', 1)}}</p></span>
        <span class="spread" :style="{ color: cc.countdown_desc_color }">∶</span>
        <span class="time-num" :style="{ background: cc.countdown_bg }"><p :style="{ color: cc.countdown_time_color }">{{getTimeNumber ('minute', 0)}}</p></span>
        <span class="time-num" :style="{ background: cc.countdown_bg }"><p :style="{ color: cc.countdown_time_color }">{{getTimeNumber ('minute', 1)}}</p></span>
        <span class="spread" :style="{ color: cc.countdown_desc_color }">∶</span>
        <span class="time-num" :style="{ background: cc.countdown_bg }"><p :style="{ color: cc.countdown_time_color }">{{getTimeNumber ('second', 0)}}</p></span>
        <span class="time-num" :style="{ background: cc.countdown_bg }"><p :style="{ color: cc.countdown_time_color }">{{getTimeNumber ('second', 1)}}</p></span>
      </div>
      <div class="desc" :style="{ color: cc.countdown_desc_color }">{{ countDownDesc }}</div>
    </div>
    <div class="subscribe-wrapper">
      <div class="desc" :style="{ color: cc.countdown_desc_color }">订阅</div>
      <hb-switch v-model="localSubscribeState" @open="handleSubscribe(1)" @close="handleSubscribe(0)"></hb-switch>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    curTime: {
      default: 0,
      type: Number,
    },
    timeList: {
      type: Array,
      default: () => []
    },
    cc: {
      type: Object,
      default: () => {},
    },
    subscribeState: {
      default: 0,
      type: Number,
    }
  },
  data () {
    return {
      localSubscribeState: false,
      hasNextSale: true,
      isOnSale: false,
    }
  },
  watch: {
    curTime(v) {
      if(v > this.lastSale?.end_time) {
        this.hasNextSale = false
      }
    },
    subscribeState(v) {
      this.localSubscribeState = Boolean(v)
    }
  },
  computed: {
    nextStartTime() {
      if(this.timeList.length == 0) {
        return 0
      }
      let nextSale = this.timeList.find(sale => {
        return sale.start_time > this.curTime
      })
      if(nextSale) {
        return nextSale.start_time //下一次打折
      } else {
        return this.timeList[this.timeList.length - 1].start_time //最后一次打折
      }
    },
    curSale() {
      return this.timeList.find(sale => {
        return Boolean(sale.start_time < this.curTime && this.curTime < sale.end_time)
      })
    },
    nextSale() {
      if(!this.timeList.length) {
        return null
      }
      let nextSale = this.timeList.find(sale => {
        return sale.start_time > this.curTime
      })
      return nextSale ? nextSale : this.lastSale
    },
    lastSale() {
      if(!this.timeList.length) {
        return null
      }
      let max = 0
      this.timeList.forEach(sale => {
        max = Math.max(max, sale.start_time)
      })
      return  max == 0 ? null : this.timeList.find(sale => sale.start_time == max)
    },
    countDownDesc() {
      if(this.timeList.length == 0) {
        return ''
      }
      if(this.curTime > this.lastSale?.end_time) {
        return '秒杀活动已结束'
      }
      if(this.curSale) {
        return '秒杀活动进行中'
      } else {
        return '距下一次秒杀倒计时'
      }
    }
  },
  methods: {
    getTimeNumber (type, index) {
      if(!this.hasNextSale) {
        return 0
      }
      let remainSeconds = 0
      if(this.curSale) {
        remainSeconds = Math.floor(this.curSale?.end_time - this.curTime)
      } else {
        remainSeconds = Math.floor(this.nextSale?.start_time - this.curTime)
      }
      var seconds = remainSeconds % 60
      var minutes = Math.floor(remainSeconds / 60) % 60
      var hours = Math.floor(Math.floor(remainSeconds / 60) / 60)
      var num = 0
      switch (type) {
        case 'hour':
          if (index == 1) {
            num = hours%10
          } else if (index == 0) {
            num = Math.floor(hours/10)
          }
          break;
        case 'minute':
          if (index == 1) {
            num = minutes%10
          } else if (index == 0) {
            num = Math.floor(minutes/10)
          }
          break;
        case 'second':
          if (index == 1) {
            num = seconds%10
          } else if (index == 0) {
            num = Math.floor(seconds/10)
          }
      }
      return num
    },
    handleSubscribe(isSubscribe) {
      this.$emit('subscribe', isSubscribe)
    }
  }
}
</script>

<style lang="less">

.cpt-count-down {
  width: 100%;
  height: 48px;
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  --switch-off-color: #A3A3A3;
  --switch-on-color: #727272;

  .count-down-wrapper {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    .timer {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 6px;
      .time-num {
        width: 13px;
        height: 17px;
        background: #FF6502;
        border-radius: 2px;
        position: relative;
        margin-right: 2px;
        p {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: HelveticaNeue;
          font-weight: 700;
          font-size: 12px;
          color: #FFF;
        }
      }
      .spread {
        font-family: HelveticaNeue;
        font-weight: 700px;
        font-size: 11px;
        margin-right: 3px;
        color: #7A7A7A;
      }
    }
  }
  .subscribe-wrapper {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    .desc {
      margin-right: 4px;
    }
    .hb-switch {
      background: var(--switch-off-color);
    }
    .hb-switch-on {
      background-color: var(--switch-on-color);
    }
  }
  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #7A7A7A;
  }
}

@font-face {
  font-family: "HelveticaNeue";
  src: url("https://static.max-c.com/static/heybox/webapp/tools/team-center/fonts/HelveticaNeue-Medium-11.ttf") format("truetype"),
    url("https://static.max-c.com/static/heybox/webapp/tools/team-center/fonts/HelveticaNeue-Medium-11.woff") format("woff");
  font-display: swap;
}
</style>